const DisabledVotingPanel = ({ closeModal }) => {
    return (
        <>
            <div className="modal__wrapper">Ocenianie wagi nie działa w zakładce Twórcy.</div>
            <button className="modal__close btnReset" onClick={closeModal}/>
        </>
    )
}

export default DisabledVotingPanel